import moment from 'moment';

export const formatDate = (date) => {
    if (!date) return 'N/A';
    return moment(date).format('DD/MM/YYYY');
};

export const formatDateTime = (date) => {
    if (!date) return 'N/A';
    return moment(date).format('DD/MM/YYYY HH:mm');
};

export const getLocalDateString = (date) => {
    if (!date) return '';
    return moment(date).format('YYYY-MM-DD');
};
